import { CardBody } from "reactstrap";
import CommonModal from "../Modal/Common/CommonModal";

interface RouteModalProps {
  isOpen: boolean;
  toggle?: () => void;
  title?: string;
  content: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xl" | "xxl"; 
}

const RouteModal: React.FC<RouteModalProps> = ({ isOpen, toggle, title, content, size = "lg" }) => {
  return (
    <CommonModal centered isOpen={isOpen} toggle={toggle} size={size}>
      <CardBody className="p-2">
        {title && <h4 className="pb-2">{title}</h4>}
        {content}
      </CardBody>
    </CommonModal>
  );
};

export default RouteModal;
